import { render } from "./ValidCode.vue?vue&type=template&id=20f4c184&scoped=true"
import script from "./ValidCode.vue?vue&type=script&lang=js"
export * from "./ValidCode.vue?vue&type=script&lang=js"

import "./ValidCode.vue?vue&type=style&index=0&id=20f4c184&scoped=true&lang=css"

import exportComponent from "D:\\wuliu\\wuliu_vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20f4c184"]])

export default __exports__